import { useParams, usePathname } from 'next/navigation';

const useLanguageSwitcher = () => {
  const { locale } = useParams();
  const pathname = usePathname();

  const onValueChange = code => {
    const [, ...restWithoutLocale] = pathname.split('/').filter(Boolean);
    const url = restWithoutLocale.join('/');
    let href = `/${code}/${url}`;

    // TODO these conditions will be removed in future

    if (url.startsWith('blog') && !['en', 'fr'].includes(code)) {
      href = `/${code}`;
    }

    if (url.startsWith('blog/') && code !== 'en') {
      href = `/${code}`;
    }

    if (url.startsWith('education') && code !== 'en') {
      href = `/${code}`;
    }

    if (locale === code) return;

    window.location.pathname = href;
  };

  return { locale, onValueChange };
};

export { useLanguageSwitcher };
